import React, { useId, useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

export default function SecretTextField({ type, InputProps = {}, ...props }) {
    const [visible, setVisible] = useState(false);
    const generatedId = useId();
    const inputId = props.id || generatedId;
    const { t } = useTranslation();
    if (type !== 'password') return <TextField {...props} type={type} InputProps={InputProps} />;
    return <TextField {...props} id={inputId} type={visible ? 'text' : 'password'} InputProps={{ ...InputProps,
        endAdornment: <><InputAdornment position="end"><IconButton type="button" edge="end" disabled={props.disabled}
            aria-label={t(visible ? 'auth.hidePassword' : 'auth.showPassword')} aria-controls={inputId}
            aria-pressed={visible} onMouseDown={event => event.preventDefault()} onClick={() => setVisible(value => !value)}>
            {visible ? <VisibilityOff /> : <Visibility />}
        </IconButton></InputAdornment>{InputProps.endAdornment}</> }} />;
}
